import {createContext} from 'react';
import Swiper from 'swiper';
import {HomeTabPage, ISecondTabKeyMap, ISecondTabs, ITabItem} from './type';
import {REGION} from '../../common/constant';
import {DEFAULT_LARGE_SIZE} from '../../common/scss/util/variable';
import {IMainSecondTab} from '../main/type';
import {ITimeTableDay, ITimeTableSecondTab} from '../timeTable/type';

const TAB_PAGE_ITEMS_KOR: ITabItem[] = [
  {tabPage: HomeTabPage.Main, title: t => t('common_tab_top')},
  {
    tabPage: HomeTabPage.TimeTable,
    title: t => t('common_tab_original_webtoon'),
  },
  {tabPage: HomeTabPage.MyPage, title: t => t('common_tab_library')},
];

const TAB_PAGE_ITEMS_GLOBAL: ITabItem[] = [
  {tabPage: HomeTabPage.Main, title: t => t('common_tab_top')},
  {
    tabPage: HomeTabPage.TimeTable,
    title: t => t('common_tab_time_table_global'),
  },
  {tabPage: HomeTabPage.MyPage, title: t => t('common_tab_library')},
];

export const TAB_PAGE_ITEMS =
  REGION === 'kor' ? TAB_PAGE_ITEMS_KOR : TAB_PAGE_ITEMS_GLOBAL;

export const DAYS_TAB_LIST: ITimeTableDay[] = [
  'mon',
  'tue',
  'wed',
  'thu',
  'fri',
  'sat',
  'sun',
];
const TIME_TABLE_KEY_LIST: ITimeTableSecondTab[] = [
  'new',
  ...DAYS_TAB_LIST,
  'complete',
];
const TIME_TABLE_TEXT_LIST: string[] = [
  'common_schedule_new',
  'common_schedule_mon',
  'common_schedule_tue',
  'common_schedule_wed',
  'common_schedule_thu',
  'common_schedule_fri',
  'common_schedule_sat',
  'common_schedule_sun',
  'common_schedule_completed',
];
export const MAIN_HOT_TAB: ISecondTabKeyMap<IMainSecondTab> = {
  key: 'hot',
  text: 'common_tab_hot',
};
export const MAIN_TODAY_FREE_SERIES_TAB: ISecondTabKeyMap<IMainSecondTab> = {
  key: 'free_publishing',
  text: 'common_tab_free_today',
};
export const MAIN_RECOMMEND_TAB: ISecondTabKeyMap<IMainSecondTab> = {
  key: 'recommend',
  text: 'recomm_tab_recommendations',
};
export const MAIN_WAITFREE_TAB: ISecondTabKeyMap<IMainSecondTab> = {
  key: 'waitfree',
  text: 'recomm_tab_gidamu',
};
export const INITIAL_SECOND_TABS: ISecondTabs = {
  [HomeTabPage.Main]: {
    selected: 'hot',
    tabList: [],
  },
  [HomeTabPage.MyPage]: {
    selected: 'recent',
    tabList: [
      {
        key: 'recent',
        text: 'library_tab_recent',
      },
      {
        key: 'like',
        text: 'library_tab_favorites',
      },
      {
        key: 'own',
        text: 'library_tab_possessed',
      },
    ],
  },
  [HomeTabPage.TimeTable]: {
    selected: 'mon',
    tabList: TIME_TABLE_KEY_LIST.map((key, index) => ({
      key,
      text: TIME_TABLE_TEXT_LIST[index],
    })),
  },
};

export function getIndex(tabPage: HomeTabPage) {
  return TAB_PAGE_ITEMS.findIndex(item => item.tabPage === tabPage);
}

// 좌우에 n개씩 복사했다면 n을 반환
export const getCopiedSlideCount = (swiper: Swiper) => {
  return swiper.params.loopedSlides || 1;
};

// TODO: GNB 상태 값을 리덕스로 관리하자.
export const GNB_STATE: {
  headerEl: HTMLDivElement | null;
  prevScroll: number;
  isHidden: boolean;
} = {
  headerEl: null,
  prevScroll: 0,
  isHidden: false,
};
export function setHeaderIsHidden(isHidden: boolean) {
  if (!GNB_STATE.headerEl) return;
  requestAnimationFrame(() => {
    GNB_STATE.isHidden = isHidden;
    const isLarge =
      (GNB_STATE.headerEl?.clientWidth as number) >= DEFAULT_LARGE_SIZE;

    if (isHidden && !isLarge) {
      GNB_STATE.headerEl?.classList.add('-translate-y-header-height');
    } else {
      GNB_STATE.headerEl?.classList.remove('-translate-y-header-height');
    }
  });
}
export function onScrollGnb(
  scrollTop: number,
  onToggleGnb?: (isHide: boolean) => void
) {
  const {prevScroll, isHidden, headerEl} = GNB_STATE;
  if (!headerEl) return;
  if (!isHidden && scrollTop > prevScroll && scrollTop > 0) {
    setHeaderIsHidden(true);
    onToggleGnb?.(true);
  } else if (isHidden && (scrollTop <= 0 || prevScroll - scrollTop > 30)) {
    setHeaderIsHidden(false);
    onToggleGnb?.(false);
  }
  GNB_STATE.prevScroll = scrollTop;
}

export const DEFAULT_GENRE_KEY = 'timetable_completed';

export const HomePageContext = createContext<IHomePageContext>({
  isCurrentHomePage: false,
});
export interface IHomePageContext {
  isCurrentHomePage: boolean;
}

export function getDelta(subLabel: string): number | 'new' {
  return subLabel === 'NEW' ? 'new' : subLabel === '-' ? 0 : Number(subLabel);
}
export const NEED_TAB_QUERY_PAGE: {[key in HomeTabPage]: boolean} = {
  [HomeTabPage.Main]: false,
  [HomeTabPage.TimeTable]: true,
  [HomeTabPage.MyPage]: true,
};

export function getContentOrdNum(index: number, hasBigContent?: boolean) {
  const ordNum = index + 1;
  return hasBigContent ? ordNum + 1 : ordNum;
}
